import { render, staticRenderFns } from "./SupportResources.vue?vue&type=template&id=618eb3c8&scoped=true&"
import script from "./SupportResources.vue?vue&type=script&lang=js&"
export * from "./SupportResources.vue?vue&type=script&lang=js&"
import style0 from "./SupportResources.vue?vue&type=style&index=0&id=618eb3c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618eb3c8",
  null
  
)

export default component.exports